import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCrm8qVvZqNJ-KCZgG9Rv1E3Z-ChHgWHtI",
  authDomain: "imessage-d2a93.firebaseapp.com",
  projectId: "imessage-d2a93",
  storageBucket: "imessage-d2a93.appspot.com",
  messagingSenderId: "175420242576",
  appId: "1:175420242576:web:ad2f6c1cd2365469183615",
  measurementId: "G-XK73CBVZWB",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const firestoreDB = firebaseApp.firestore();
const auth = firebase.auth();

const provider = new firebase.auth.GoogleAuthProvider();

export default firestoreDB;
export { auth, provider };
